/** Where a class is in its schedule, for the class pickers. Pure: pass `now` to test. */

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const DAY_MS = 86400000;
const RANK = { in_progress: 0, upcoming: 1, unscheduled: 2, ended: 3 };
const NEAR_DAYS = 14;

const monthDay = (d) => `${MONTHS[d.getMonth()]} ${d.getDate()}`;
const weekdayMonthDay = (d) => `${DAYS[d.getDay()]}, ${monthDay(d)}`;
const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());

function timeLabel(d) {
  const h = d.getHours();
  return `${h % 12 || 12}:${String(d.getMinutes()).padStart(2, "0")} ${h >= 12 ? "PM" : "AM"}`;
}

function startsLabel(first, now) {
  const days = Math.round((startOfDay(first) - startOfDay(now)) / DAY_MS);
  if (days <= 0) return "Starts today";
  if (days === 1) return "Starts tomorrow";
  if (days <= NEAR_DAYS) return `Starts in ${days} days`;
  return `Starts ${monthDay(first)}`;
}

function scheduleSpan(course) {
  const slots = (Array.isArray(course?.schedule) ? course.schedule : [])
    .map((s) => ({ start: new Date(s?.start), end: new Date(s?.end) }))
    .filter((s) => !Number.isNaN(s.start.getTime()) && !Number.isNaN(s.end.getTime()));
  if (slots.length === 0) return null;
  return {
    first: new Date(Math.min(...slots.map((s) => s.start))),
    last: new Date(Math.max(...slots.map((s) => s.end))),
  };
}

/** { kind: "in_progress" | "upcoming" | "ended" | "unscheduled", label, detail, start } */
export function classStatus(course, now = new Date()) {
  const span = scheduleSpan(course);
  if (!span) return { kind: "unscheduled", label: "Not scheduled", detail: null, start: null };
  const { first, last } = span;
  if (now < first) {
    return { kind: "upcoming", label: startsLabel(first, now), detail: `${weekdayMonthDay(first)} · ${timeLabel(first)}`, start: first };
  }
  if (now <= last) {
    return { kind: "in_progress", label: "In progress", detail: `Through ${weekdayMonthDay(last)}`, start: first };
  }
  return { kind: "ended", label: `Ended ${monthDay(last)}`, detail: null, start: first };
}

/** In progress first, then soonest upcoming, then not scheduled, then ended; ties by title. Returns a new array. */
export function sortByStatus(courses, now = new Date()) {
  return courses
    .map((c) => ({ c, s: classStatus(c, now) }))
    .sort((a, b) =>
      RANK[a.s.kind] - RANK[b.s.kind]
      || (a.s.start && b.s.start ? a.s.start - b.s.start : 0)
      || String(a.c.title || "").localeCompare(String(b.c.title || "")))
    .map(({ c }) => c);
}
